import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Esse pack funciona no meu equipamento?',
      answer: 'Sim. O pack é totalmente compatível com Hotone Ampero II Stage, Ampero II MP350 e Ampero Stomp II. Basta carregar os arquivos no seu equipamento e começar a usar.'
    },
    {
      question: 'É download imediato?',
      answer: 'Sim! Após a confirmação do pagamento, você recebe acesso instantâneo para fazer o download de todos os 191 captures. Não há tempo de espera.'
    },
    {
      question: 'Serve para gravação e palco?',
      answer: 'Com certeza! As captures foram criadas e testadas especificamente para ambos os cenários. Você pode usar direto na mesa de som ao vivo ou conectar na sua interface de áudio para gravações profissionais.'
    },
    {
      question: 'Preciso de IRs externos?',
      answer: 'Não. As captures já estão completas e prontas para uso. Você não precisa comprar ou instalar nenhum impulse response adicional. É só carregar e tocar.'
    },
    {
      question: 'Como faço para instalar os captures?',
      answer: 'É muito simples! Após o download, você conecta seu Ampero II ao computador via USB, abre o software Ampero Control e importa os arquivos. O processo leva apenas alguns minutos.'
    },
    {
      question: 'Posso usar em afinações baixas (drop tuning)?',
      answer: 'Sim! Os captures foram ajustados para funcionar perfeitamente em drop tunings, mantendo definição e peso mesmo em afinações baixas como Drop C, Drop B e até mais graves.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="relative py-24 bg-black">
      <div className="max-w-4xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Perguntas <span className="text-orange-500">Frequentes</span>
          </h2>
          <p className="text-xl text-gray-400">
            Tire suas dúvidas antes de comprar
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-zinc-950 border border-zinc-800 hover:border-orange-500/50 transition-colors duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
              >
                <h3 className="text-lg md:text-xl font-bold text-white pr-4">
                  {faq.question}
                </h3>
                <div className={`w-10 h-10 flex items-center justify-center bg-orange-500/10 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-2xl text-orange-500"></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-6">
                  <p className="text-gray-400 leading-relaxed border-t border-zinc-800 pt-4">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-4">Ainda tem dúvidas?</p>
          <a
            href="mailto:contato@tomcore.com"
            className="inline-flex items-center gap-2 text-orange-500 hover:text-orange-400 font-bold transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-mail-fill text-xl"></i>
            Entre em contato conosco
          </a>
        </div>
      </div>
    </section>
  );
}
